import { useMap } from "react-leaflet";

export function ChangeMapCenter({ center, zoom }) {
  const map = useMap();
  map.setView(center, zoom);
  return null;
}
